import { MealSourceDto } from "../api";

export function computeResultType(mealSource: MealSourceDto) {
  return mealSource.indicator == "DISH"
    ? "Gericht"
    : mealSource.indicator == "PURCHASE"
      ? "Produkt"
      : mealSource.indicator == "MEAL"
        ? "Gericht"
        : mealSource.indicator == "FOOD"
          ? "Lebensmittel"
          : "Mahlzeit";
}

export function getMealSourceKey(searchResult: MealSourceDto) {
  return [
    searchResult.indicator,
    searchResult.indicator == "MEALS_FOR_DAY"
      ? searchResult.description
      : searchResult.id,
  ].join();
}
